import * as yup from "yup";

import { IdentityCardBaseFormType } from "@/components/organisms/Forms/IdentityCard/formType";
import { Shape } from "@/core/yup";
import i18n from "@/i18n";
import { validateBankAccount } from "@/validations";

import { formSchemaCommunication } from "../components/Contact/formSchema";
import { FormType } from "./utils";

export const formSchemaPerson = yup.object<{}, Shape<FormType>>({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    relationType: yup.string().required(),
});

export const formSchemaPersonalInfo = yup.object<{}, Shape<FormType>>({
    language: yup.string().required(),
    birthdate: yup.date().birthdate().nullable(),
    civilStatus: yup.string().required(),
    gender: yup.string().required().nullable(),
    title: yup.string().required(),
});

export const formSchemaFinance = yup.object<{}, Shape<FormType>>({
    financeAccountType: yup.string(),

    financeAccount: yup
        .string()
        .requiredIf(["financeAccountType", "financeAccount"])
        .test("accountNumber", "Invalid format", function testAccountNumber() {
            const { financeAccountType, financeAccount } = this.parent;
            return validateBankAccount(financeAccountType, financeAccount);
        }),
});

export const formSchemaIdentityCard = yup.object<{}, Shape<IdentityCardBaseFormType>>({
    identityCardNationalNumber: yup.string().exactLength(11),
    identityCardValidFrom: yup
        .date()
        .min(yup.ref("birthdate"), i18n.t("Validations.DateBeforeBirthDate"))
        .presentOrPast()
        .nullable(),
    identityCardValidTo: yup.date().onFuture().nullable(),
});

export const formSchemaDriverLicense = yup.object<{}, Shape<FormType>>({
    driversLicenseIssueDate: yup
        .date()
        .minXYearsOld(16, "birthdate")
        .min(yup.ref("birthdate"), i18n.t("Validations.DateBeforeBirthDate"))
        .presentOrPast()
        .nullable(),
});

export const formSchema = yup
    .object<{}, Shape<FormType>>()
    .concat(formSchemaPerson)
    .concat(formSchemaPersonalInfo)
    .concat(formSchemaFinance)
    .concat(formSchemaIdentityCard)
    .concat(formSchemaDriverLicense)
    .concat(formSchemaCommunication);
